import { useEffect, useState } from "react";
import { getOnboardingStorePreview, type OnboardingPreview } from "../services/OnboardingPreviewService";
import { EXAMPLE_PREVIEW_ZIP } from "../components/home-feed/homeFeedLogic";

// One request per page load: the ZIP step, the plan step and the "not covered"
// state all show the same example deals (the home feed's example ZIP).
let cached: Promise<OnboardingPreview | null> | null = null;

function loadExamplePreview(): Promise<OnboardingPreview | null> {
  if (!cached) {
    cached = getOnboardingStorePreview(EXAMPLE_PREVIEW_ZIP).catch(() => {
      cached = null; // let a later screen retry
      return null;
    });
  }
  return cached;
}

/** Test hook: forget the cached example preview. */
export function resetExamplePreviewCache() {
  cached = null;
}

/** Real priced deals from the example ZIP; `undefined` while loading, `null` when unavailable. */
export default function useExamplePreview(enabled = true): OnboardingPreview | null | undefined {
  const [preview, setPreview] = useState<OnboardingPreview | null | undefined>(undefined);
  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    void loadExamplePreview().then((result) => {
      if (!cancelled) setPreview(result);
    });
    return () => {
      cancelled = true;
    };
  }, [enabled]);
  return preview;
}
